import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberServicesEscalations defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberServicesEscalationsService } from 'services/memberServicesEscalations';
 *
 * // create service instance and send/cancel request
 * const memberServicesEscalationsService = new MemberServicesEscalationsService();
 * const result = await memberServicesEscalationsService.fetchData( '<user-id>' ); // fetch data
 * memberServicesEscalationsService.cancel(); // cancel an active request
 */
export class MemberServicesEscalationsService extends HttpService {

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
